import { timeParse } from 'd3'

const estimates = [
  {
    eps_report_date: '2021-02-02',
    bfid: 'HKP8JK-R',
    item: 'EPS',
    fiscal_date: '2021-03-31',
    cons_end_date: '2021-02-02',
    consensus_currency: 'CNY',
    street_average: '12.672123',
    num_analyst: '23',
    cons_start_date: '2021-02-02',
    fe_per_rel: '1',
    adjdate: '',
    fe_median: '12.76',
    fe_low: '10.42',
    fe_high: '15.45',
    fe_std_dev: '1.227798',
    fe_up: '9',
    fe_down: '12',
    max_fiscal: '2020-12-31',
    leaders_date: '2021-02-18',
    '90daccuracy': '0.8552085161',
    '90daverage': '12.60614872',
    '180daccuracy': '0.8569535613',
    '180daverage': '12.62191868',
    '365daccuracy': '0.8595376611',
    '365daverage': '12.6049757',
    '90dspread': '-0.0052062357',
    '180dspread': '-0.0039618108',
    '365dspread': '-0.0052988464',
    ticker: 'BABA.US',
  },
  {
    eps_report_date: '2021-02-02',
    bfid: 'HKP8JK-R',
    item: 'EPS',
    fiscal_date: '2021-06-30',
    cons_end_date: '2021-02-02',
    consensus_currency: 'CNY',
    street_average: '18.094854',
    num_analyst: '13',
    cons_start_date: '2021-02-02',
    fe_per_rel: '2',
    adjdate: '',
    fe_median: '18.601921',
    fe_low: '15.48',
    fe_high: '19.781188',
    fe_std_dev: '1.470433',
    fe_up: '2',
    fe_down: '8',
    max_fiscal: '2020-12-31',
    leaders_date: '2021-02-18',
    '90daccuracy': '0.8552085161',
    '90daverage': '17.97576904',
    '180daccuracy': '0.8569535613',
    '180daverage': '18.26419258',
    '365daccuracy': '0.8595376611',
    '365daverage': '17.75017548',
    '90dspread': '-0.0065811528',
    '180dspread': '0.0093583567',
    '365dspread': '-0.0190484747',
    ticker: 'BABA.US',
  },
  {
    eps_report_date: '2021-02-02',
    bfid: 'HKP8JK-R',
    item: 'EPS',
    fiscal_date: '2021-09-30',
    cons_end_date: '2021-02-02',
    consensus_currency: 'CNY',
    street_average: '17.86016',
    num_analyst: '12',
    cons_start_date: '2021-02-02',
    fe_per_rel: '3',
    adjdate: '',
    fe_median: '17.83',
    fe_low: '15.49',
    fe_high: '20.459828',
    fe_std_dev: '1.480178',
    fe_up: '3',
    fe_down: '7',
    max_fiscal: '2020-12-31',
    leaders_date: '2021-02-18',
    '90daccuracy': '0.8552085161',
    '90daverage': '17.54526138',
    '180daccuracy': '0.8569535613',
    '180daverage': '17.77578735',
    '365daccuracy': '0.8595376611',
    '365daverage': '17.28620911',
    '90dspread': '-0.0176313445',
    '180dspread': '-0.0047240402',
    '365dspread': '-0.0321358219',
    ticker: 'BABA.US',
  },
  {
    eps_report_date: '2021-02-02',
    bfid: 'HKP8JK-R',
    item: 'EPS',
    fiscal_date: '2021-12-31',
    cons_end_date: '2021-02-02',
    consensus_currency: 'CNY',
    street_average: '24.800867',
    num_analyst: '12',
    cons_start_date: '2021-02-02',
    fe_per_rel: '4',
    adjdate: '',
    fe_median: '24.955',
    fe_low: '21.86',
    fe_high: '27.68',
    fe_std_dev: '1.888034',
    fe_up: '3',
    fe_down: '7',
    max_fiscal: '2020-12-31',
    leaders_date: '2021-02-18',
    '90daccuracy': '0.8552085161',
    '90daverage': '24.55044365',
    '180daccuracy': '0.8569535613',
    '180daverage': '24.92928314',
    '365daccuracy': '0.8595376611',
    '365daverage': '24.47935486',
    '90dspread': '-0.0100973537',
    '180dspread': '0.0051779016',
    '365dspread': '-0.0129637364',
    ticker: 'BABA.US',
  },
  {
    eps_report_date: '2021-02-02',
    bfid: 'HKP8JK-R',
    item: 'EPS',
    fiscal_date: '2022-03-31',
    cons_end_date: '2021-02-02',
    consensus_currency: 'CNY',
    street_average: '15.141638',
    num_analyst: '12',
    cons_start_date: '2021-02-02',
    fe_per_rel: '5',
    adjdate: '',
    fe_median: '15.585',
    fe_low: '12.41',
    fe_high: '17.13',
    fe_std_dev: '1.760626',
    fe_up: '5',
    fe_down: '4',
    max_fiscal: '2020-12-31',
    leaders_date: '2021-02-18',
    '90daccuracy': '0.8552085161',
    '90daverage': '14.94913483',
    '180daccuracy': '0.8569535613',
    '180daverage': '15.34367561',
    '365daccuracy': '0.8595376611',
    '365daverage': '14.79830837',
    '90dspread': '-0.0127134779',
    '180dspread': '0.0133431843',
    '365dspread': '-0.022674555',
    ticker: 'BABA.US',
  },
  {
    eps_report_date: '2021-02-02',
    bfid: 'HKP8JK-R',
    item: 'EPS',
    fiscal_date: '2022-06-30',
    cons_end_date: '2021-02-02',
    consensus_currency: 'CNY',
    street_average: '21.555663',
    num_analyst: '3',
    cons_start_date: '2021-02-02',
    fe_per_rel: '6',
    adjdate: '',
    fe_median: '22.01',
    fe_low: '18.96',
    fe_high: '23.696989',
    fe_std_dev: '2.400954',
    fe_up: '0',
    fe_down: '1',
    max_fiscal: '2020-12-31',
    leaders_date: '2021-02-18',
    '90daccuracy': '0.8552085161',
    '90daverage': '20.48500061',
    '180daccuracy': '0.8569535613',
    '180daverage': '20.48500061',
    '365daccuracy': '0.8595376611',
    '365daverage': '20.48500061',
    '90dspread': '-0.0496696867',
    '180dspread': '-0.0496696867',
    '365dspread': '-0.0496696867',
    ticker: 'BABA.US',
  },
  {
    eps_report_date: '2021-02-02',
    bfid: 'HKP8JK-R',
    item: 'EPS',
    fiscal_date: '2022-09-30',
    cons_end_date: '2021-02-02',
    consensus_currency: 'CNY',
    street_average: '21.363556',
    num_analyst: '3',
    cons_start_date: '2021-02-02',
    fe_per_rel: '7',
    adjdate: '',
    fe_median: '21.37',
    fe_low: '18.52',
    fe_high: '24.200667',
    fe_std_dev: '2.840339',
    fe_up: '1',
    fe_down: '0',
    max_fiscal: '2020-12-31',
    leaders_date: '2021-02-18',
    '90daccuracy': '0.8552085161',
    '90daverage': '19.94499969',
    '180daccuracy': '0.8569535613',
    '180daverage': '19.94499969',
    '365daccuracy': '0.8595376611',
    '365daverage': '19.94499969',
    '90dspread': '-0.066400744',
    '180dspread': '-0.066400744',
    '365dspread': '-0.066400744',
    ticker: 'BABA.US',
  },
  {
    eps_report_date: '2021-02-02',
    bfid: 'HKP8JK-R',
    item: 'EPS',
    fiscal_date: '2022-12-31',
    cons_end_date: '2021-02-02',
    consensus_currency: 'CNY',
    street_average: '28.627092',
    num_analyst: '3',
    cons_start_date: '2021-02-02',
    fe_per_rel: '8',
    adjdate: '',
    fe_median: '28.24',
    fe_low: '26.89',
    fe_high: '30.751275',
    fe_std_dev: '1.959526',
    fe_up: '0',
    fe_down: '1',
    max_fiscal: '2020-12-31',
    leaders_date: '2021-02-18',
    '90daccuracy': '0.8552085161',
    '90daverage': '27.56500053',
    '180daccuracy': '0.8569535613',
    '180daverage': '27.56500053',
    '365daccuracy': '0.8595376611',
    '365daverage': '27.56500053',
    '90dspread': '-0.0371009409',
    '180dspread': '-0.0371009409',
    '365dspread': '-0.0371009409',
    ticker: 'BABA.US',
  },
  {
    eps_report_date: '2021-02-02',
    bfid: 'HKP8JK-R',
    item: 'EPS',
    fiscal_date: '2023-03-31',
    cons_end_date: '2021-02-02',
    consensus_currency: 'CNY',
    street_average: '17.750174',
    num_analyst: '3',
    cons_start_date: '2021-02-02',
    fe_per_rel: '9',
    adjdate: '',
    fe_median: '18.16',
    fe_low: '14.94',
    fe_high: '20.150521',
    fe_std_dev: '2.629325',
    fe_up: '0',
    fe_down: '0',
    max_fiscal: '2020-12-31',
    leaders_date: '2021-02-18',
    '90daccuracy': '0.8552085161',
    '90daverage': '16.54999924',
    '180daccuracy': '0.8569535613',
    '180daverage': '16.54999924',
    '365daccuracy': '0.8595376611',
    '365daverage': '16.54999924',
    '90dspread': '-0.0676147714',
    '180dspread': '-0.0676147714',
    '365dspread': '-0.0676147714',
    ticker: 'BABA.US',
  },
]

const parseDate = timeParse('%Y-%m-%d')

export default estimates.map(d => {
  d['date'] = parseDate(d['fiscal_date'])
  return d
})
